import { getTheme, getLayout } from './rateChartConfig';

// Tiny schematic pages for the template and layout pickers. Their colours are the theme's own, so they are inline styles.

const bar = (width, background, height = 3) => (
    <div style={{ height, width, borderRadius: 1, background, flex: 'none' }} />
);

/** One of the ready-made templates: a miniature of the whole page. */
export function PresetThumb({ preset }) {
    const th = getTheme(preset.theme);
    const tk = getLayout(preset.layout, th);
    const frame = preset.layout === 'frame';
    const heritage = preset.layout === 'heritage';
    const card = preset.layout === 'card';
    const tall = preset.layout === 'poster' || heritage;
    const centered = tall || frame;
    const accent = preset.layout === 'minimal' ? th.price : th.acc;

    const block = (widths) => (
        <div
            style={{
                display: 'flex', flexDirection: 'column', gap: 4, borderRadius: 4,
                background: card ? '#fff' : 'transparent', border: card ? '1px solid #E6E0D8' : 'none', padding: card ? '4px 5px' : 0,
            }}
        >
            {widths.map((w, i) => (
                <div key={i} style={{ display: 'flex', justifyContent: 'space-between', gap: 4 }}>
                    {bar(w, '#D9D2C8')}
                    {bar('16%', th.price)}
                </div>
            ))}
        </div>
    );

    return (
        <div
            style={{
                height: 150, borderRadius: 9, overflow: 'hidden', background: tk.bodyBg, display: 'flex', flexDirection: 'column',
                border: frame ? '2px double ' + th.hdr : heritage ? '1px solid ' + th.acc : '1px solid #ECE6DE',
            }}
        >
            <div
                style={{
                    height: tall ? 42 : 30, flex: 'none', background: th.hdr, display: 'flex', flexDirection: 'column', justifyContent: 'center',
                    alignItems: centered ? 'center' : 'flex-start', gap: 4, padding: '0 10px',
                    borderBottom: th.hdr === '#FFFFFF' ? '1px solid #E6E0D8' : 'none',
                }}
            >
                <div style={{ width: '46%', height: 7, borderRadius: 2, background: th.hdrInk }} />
                <div style={{ width: '28%', height: 3, borderRadius: 2, background: th.hdrInk, opacity: 0.55 }} />
            </div>
            <div style={{ height: 3, flex: 'none', background: accent }} />
            <div style={{ flex: 1, padding: '8px 9px', display: 'grid', gridTemplateColumns: preset.cols === 2 ? '1fr 1fr' : '1fr', gap: '7px 8px', alignContent: 'start' }}>
                {block(['58%', '48%', '62%'])}
                {block(['54%', '44%'])}
            </div>
        </div>
    );
}

/** A layout (the "সাজ") drawn in the current colour. */
export function LayoutThumb({ layoutId, themeId }) {
    const th = getTheme(themeId);
    const k = getLayout(layoutId, th);
    return (
        <div style={{ height: 52, border: k.thBd, borderRadius: 6, overflow: 'hidden', background: k.thBg, padding: k.thPad }}>
            <div style={{ height: k.thHdrH, background: k.thHdrBg, borderBottom: k.thHdrBd }} />
            <div style={{ padding: 5, display: 'flex', flexDirection: 'column', gap: 3, alignItems: k.thAlign }}>
                {bar('62%', k.thBandBg, 4)}
                {bar('100%', '#DED9D1', 2)}
                {bar('100%', '#DED9D1', 2)}
            </div>
        </div>
    );
}

/** A colour swatch: header colour with the accent band along its foot. */
export function ThemeSwatch({ themeId }) {
    const th = getTheme(themeId);
    return (
        <div style={{ height: 36, borderRadius: 7, background: th.hdr, position: 'relative', overflow: 'hidden', border: '1px solid rgba(28,24,21,.08)' }}>
            <div style={{ position: 'absolute', left: 0, right: 0, bottom: 0, height: 8, background: th.acc }} />
        </div>
    );
}
